
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rent",
      function () {
        return require("private-next-pages/rent.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rent"])
      });
    }
  